const TransferAnimation = {
    mounted() {
        setTimeout(() => {
            const parentEl = this.el;

            parentEl.style.transition = "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out";

            const moneyEmojis = ["💸", "💰", "💵"];

            const createFloatingMoney = () => {
                const money = document.createElement("div");
                money.textContent = moneyEmojis[Math.floor(Math.random() * moneyEmojis.length)];
                money.style.position = "absolute";
                money.style.left = "-30px";
                money.style.top = "50%";
                money.style.transform = "translateY(-50%)";
                money.style.fontSize = "24px";
                money.style.pointerEvents = "none";
                money.style.zIndex = "10";

                parentEl.parentElement?.appendChild(money);

                money.animate(
                    [
                        {
                            left: "-30px",
                            opacity: 1,
                            transform: "translateY(-50%) scale(1)",
                        },
                        {
                            left: "50%",
                            opacity: 0.8,
                            transform: "translateY(-50%) scale(1.2)",
                        },
                        {
                            left: "calc(100% + 30px)",
                            opacity: 0,
                            transform: "translateY(-50%) scale(0.5)",
                        },
                    ],
                    {
                        duration: 1200,
                        easing: "ease-in-out",
                    }
                ).onfinish = () => {
                    money.remove();
                };
            };

            for (let i = 0; i < 5; i++) {
                setTimeout(() => createFloatingMoney(), i * 300);
            }

            let pulseCount = 0;
            const maxPulses = 6;

            const pulse = () => {
                if (pulseCount < maxPulses) {
                    parentEl.style.transform = "scale(1.15)";
                    parentEl.style.boxShadow = "0 0 20px rgba(var(--color-primary-rgb), 0.6)";
                    setTimeout(() => {
                        parentEl.style.transform = "scale(1)";
                        parentEl.style.boxShadow = "none";
                        pulseCount++;
                        setTimeout(pulse, 250);
                    }, 250);
                }
            };

            pulse();
        }, 500);
    },
};

export default TransferAnimation;
